import DashboardPage from './DashboardPage'
export { DashboardPage }
export default DashboardPage
